import React, {Component} from "react";
import {connect} from 'react-redux';
import {withRouter} from "react-router-dom";
import {DiscussionEmbed} from 'disqus-react';
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import disqusPollStyle from "assets/jss/material-kit-react/views/pollTemplateSections/disqusPollStyle.jsx";

class DisqusSection extends Component {
  render() {
    const {classes, poll} = this.props;

    const disqusConfig = {
      url: `http://www.pollpals.com/poll/${poll.data.poll_hash}`,
      identifier: poll.data.poll_id,
      title: poll.data.question,
    }

    return (
      <div className={classes.section}>
        <div className={classes.comments}>
          <DiscussionEmbed shortname='pollpals' config={disqusConfig} />
        </div>
      </div>
    );
  }
}

const pageWithStyles = withStyles(disqusPollStyle)(DisqusSection);

function  mapStateToProps(state) {
  return {
    poll: state.poll,
  }
}

export default withRouter(connect(mapStateToProps)(pageWithStyles));



// WEBPACK FOOTER //
// ./src/views/PollTemplate/DisqusSection.js